import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Jiankang from '../views/Jiankang.vue';
import Tuikuan from '../views/Tuikuan.vue';
import Order from '../views/Order.vue';
import dkOrder from '../views/dkOrder.vue';
import Shebei from '../views/Shebei.vue';
Vue.use(VueRouter);
const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/jiankang',
        name: 'Jiankang',
        component: Jiankang
    },
    {
        path: '/order',
        name: 'Order',
        component: Order
    },
    {
        path: '/dkorder',
        name: 'dkorder',
        component: dkOrder
    },
    {
        path: '/tuikuan',
        name: 'Tuikuan',
        component: Tuikuan
    },
    {
        path: '/shebei',
        name: 'Shebei',
        component: Shebei
    }
];
const router = new VueRouter({
    routes
});
export default router;
